import { render, staticRenderFns } from "./MatrixCategoryToggle.vue?vue&type=template&id=6aede94d&scoped=true&"
import script from "./MatrixCategoryToggle.vue?vue&type=script&lang=js&"
export * from "./MatrixCategoryToggle.vue?vue&type=script&lang=js&"
import style0 from "./MatrixCategoryToggle.vue?vue&type=style&index=0&id=6aede94d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aede94d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
